export default __webpack_public_path__ + "static/media/sport-m.41d41839.webp";